import React, { useState, useEffect , useRef, useCallback} from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepButton,
  Grid,
  FormHelperText,
  Button,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import ReportDetail from './reportSteps/reportDetail';
import { useLocation } from 'react-router-dom';
import { getclientProperty } from '../../../actions/property';
import GenerateReport from "./reportSteps/generateReport"
import { addTree, editTree as editTrees, setTree } from "../../../actions/tree"
import { ClientDetail, PropertyDetail, Objective} from './reportSteps/editReportDetail';
import { AddTree, TreeImage, Species, TreeHeight, HealthRating, HardscapeDamage, Recomendation,
  InspectionLevel ,HeritageTree, TreeDistance,Observations, MapImage, SecondaryReport,TreeJurisdiction, DiseasePresent} from './reportSteps/editTree';
  // import MapImage from "./reportSteps/mapImage"
import { addReport, getReport, updateReport } from "../../../actions/report"
import { fetchAllTrees } from '../../../actions/tree';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import html2canvas  from "html2canvas"
import {s3} from "../../common/awsS3"

const useStyles = makeStyles(()=>({
  icon:{
    color: "rgb(115 74 153) !important"
  }
}))

const steps = ['Report Detail', 'Client', 'Property', 'Objective', 'Tree', "Map Image", 'Tree Image',
'Species', 'Tree Height', 'Health Rating', 'Hardscape Damage','Inspection Level','Tree Distance',
'Heritage Tree', 'Tree Jurisdiction', 'Dise ase','Obser vations',  'Secondary Report','Recomen dation', 'Generate Report'];

const EditReport = () => {
  const classes = useStyles()
  const screenRef = useRef(null)
  const canvasRef = useRef(null)
  const dispatch = useDispatch()
  const location = useLocation()
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({})
  const {reports, editReport} = useSelector(({report})=> report)
  const {trees, editTree, reportTrees} = useSelector(({tree})=> tree)
  const [isFormValid, setIsFormValid] = useState(true)
  const [clients, setClients] = useState("")
  const [properties, setProperties] = useState("")
  const [objective, setObjective] = useState("")
  const [image, setImage] = useState([]);
  const [editClick, setEditClick] = useState(false)
  const [status, setStatus] = useState("")
  const [editReportDetail, setEditReportDetail] = useState(editReport)
  const [editTreeClick, setEditTreeClick] = useState(false)
  const [handleTreeClick, setHandleTreeClick] = useState(false)
  const [editTreeData, setEditTreeData] = useState()

  const [show, setShow] = useState(false)
  const [imageUrl, setImageUrl]= useState("")
  const [staticMap, setStaticMap] = useState("")
  


  useEffect(()=>{
    location.path !== "/addReport" &&
    dispatch({type:"EMPTY REPORTS", payload:{}})
    dispatch({type:"EMPTY TREES", payload:{}})
  },[])

  useEffect(()=>{
    dispatch(fetchAllTrees(editReport?._id))
  },[editReport?._id])

  useEffect(()=>{
    location?.state?.data ==="/reports" && activeStep===0 && dispatch(setTree(reportTrees[reportTrees?.length-1]))
  },[reportTrees])

  useEffect(()=>{
    location?.state?.data?.clientName ? setActiveStep(1) : 
    location?.state?.data?.propertyName && setActiveStep(2) 
  },[])

  useEffect(()=>{
    editTreeClick ?
    setEditTreeData(editTree) :
    setEditTreeData("")
  },[editTreeClick])

  useEffect(()=>{
    editClick && setActiveStep(6)
  },[editClick])

  useEffect(()=>{
    dispatch(getReport())
  },[])


  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const updateData = (newData) => {
    setStaticMap(newData);
  }

  const handleStatus =()=>{
    if(formik.values.reportName &&
      formik.values.client &&
      formik.values.property &&
      formik.values.objective &&
      formik.values.treeLat &&
      formik.values.treeLong &&
      formik.values.level &&
      formik.values.healthRating!=="null" &&
      formik.values.observations &&
      formik.values.recomendation &&
      formik.values.treeAddress &&
      formik.values.hardscapedamage!=="null" &&
      formik.values.treeDistance!=="null" &&
      formik.values.treeMapImage &&
      formik.values.treeImage?.length &&
      formik.values.treeHeight &&
      formik.values.heritageTree!=="null" &&
      formik.values.recomendationDesc){
        setStatus("completed")
      }else{
        setStatus("draft")
      }
  }

useEffect(()=>{
  editTreeClick && setActiveStep(7)
},[])

  const completedSteps = () => {
    return Object.keys(completed).length;
  };
  //  useEffect(()=>{
  //   setAddReportData(reports)
  //  },[reports])

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    setActiveStep((prevStep) => prevStep + 1)
  };

  const handleCompleteWithDots =()=>{
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    // setActiveStep((prevStep) => prevStep + 1)
  }

  // const handleStepClick = (step) => {
  //     setActiveStep(step)
  // }
  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      reportName: editReportDetail?.reportName ? editReportDetail?.reportName : reports?.reportName ? reports?.reportName :"",
      client: location?.state?.data?.propertyName ? location?.state?.data?.client : location?.state?.data?.clientName ? location?.state?.data: editReportDetail?.client ? editReportDetail?.client: "",
      property: location?.state?.data?.propertyName ? location?.state?.data  : editReportDetail?.property ? editReportDetail?.property :"",
      objective: editReportDetail?.objective? editReportDetail?.objective :"The Objective of this report is",
      treeLat: editTree?.treeLocation?.coordinates ? editTree?.treeLocation?.coordinates[1]:"",
      treeLong:    editTree?.treeLocation?.coordinates ? editTree?.treeLocation?.coordinates[0]:"" ,
      treeAddress:   editTree?.treeAddress ? editTree?.treeAddress:"",
      treeImage: editTree?.treeImages ? editTree?.treeImages:"",
      treeMapImage:    editTree?.treeMapImage ? editTree?.treeMapImage:"" ,
      species:    editTree?.species ? editTree?.species :"",
      treeHeight:   editTree?.treeHeight ? editTree?.treeHeight:"" ,
      treeHeightUnit: editTree?.treeHeightUnit ? editTree?.treeHeightUnit : "",
      healthRating:  editTree?.healthRating? editTree?.healthRating?._id:"",
      hardscapedamage:   editTree?.hardScapeDamage ? editTree?.hardScapeDamage:"" ,
      damageReason:   editTree?.damageReason ? editTree?.damageReason:"",
      hardScapeDamageImage: editTree?.hardScapeDamageImage ? editTree?.hardScapeDamageImage :"",
      hardScapeDamageImageCaption:  editTree?.hardScapeDamageImageCaption ? editTree?.hardScapeDamageImageCaption :"",
      level:   editTree?.inspectionLevel ? editTree?.inspectionLevel:"",
      treeDistance:   editTree?.isTreeDistance!=="null" ? editTree?.isTreeDistance:"",
      treeDistanceDesc:  editTree?.treeDistanceDesc  ? editTree?.treeDistanceDesc:"",
      treeDistanceImage: editTree?.treeDistanceImage ? editTree?.treeDistanceImage :"",
      treeDistanceImageCaption: editTree?.treeDistanceImageCaption ? editTree?.treeDistanceImageCaption :"",
      heritageTree:  editTree?.isHeritageTree!=="null" ? editTree?.isHeritageTree:"",
      heritageDesc:  editTree?.heritageDesc ? editTree?.heritageDesc:"",
      heritageImage: editTree?.heritageImage ? editTree?.heritageImage :"",
      heritageImageCaption: editTree?.heritageImageCaption ? editTree?.heritageImageCaption :"",
      jurisdiction: editTree?.jurisdiction? editTree?.jurisdiction :"",
      diseasePresent: editTree?.diseasePresent!=="null"? editTree?.diseasePresent:"",
      diseasePresentDesc:  editTree?.diseasePresentDesc ? editTree?.diseasePresentDesc:"",
      diseasePresentImage:editTree?.diseasePresentImage ? editTree?.diseasePresentImage:"",
      diseasePresentImageCaption: editTree?.diseasePresentImageCaption ? editTree?.diseasePresentImageCaption:"",
      observations:  editTree?.observations ? editTree?.observations:"My Observation for this tree is" ,
      recomendation:  editTree?.recomendation? editTree?.recomendation?._id:"",
      secondaryReport: editTree?.isSecondaryReportRequired!=="null" ? editTree?.isSecondaryReportRequired :""
    },

    validationSchema: Yup.object({
      reportName: Yup.string()
        .required('Please name your report'),
    }),

    onSubmit: () => {
      const reportId = editReport?._id
      switch(activeStep){
        case 0:
          if(formik.values.reportName!==""){
            handleStatus()
            const data ={
              reportName: formik.values.reportName ? formik.values.reportName:"",
              pageNumber:activeStep,
              status:status
            }
              reportId ? dispatch(updateReport(reportId, data)):
              dispatch(addReport(data))
              handleComplete()  
          }        
        break;
        case 1:
          if(formik.values.client!==""){
            handleStatus()
            const data ={
            reportName: formik.values.reportName ? formik.values.reportName : "",
            client: formik.values.client ? formik.values.client?._id : "",
            property: "",
            pageNumber: activeStep,
            status: status
          }
          setProperties("")
            reportId ? dispatch(updateReport(reportId, data)):
            dispatch(addReport(data))
            handleComplete()
          }    
        break;
        case 2:
          if(formik.values.property!==""){
            handleStatus()
          const data ={
            pageNumber:activeStep,
            property: formik.values.property ? formik.values.property?._id:"",
            status:status
          }
          reportId ? dispatch(updateReport(reportId, data)):
          dispatch(addReport(data))
          handleComplete()                    
          }
        break;
        case 3:
          if(formik.values.objective!== "" && formik.values.objective!=="The Objective of this report is" && formik.values.objective!== undefined){
            handleStatus()
          const data ={
            pageNumber:activeStep,
            objective: formik.values.objective ? formik.values.objective :"",
            status:status
          }
            reportId ? dispatch(updateReport(reportId, data)):
            dispatch(addReport(data))
            handleComplete()          
        }
        break;
        case 4:
          handleStatus()
          setShow(false)
          if(formik.values.treeLat!==""&& formik.values.treeLong!==""&& formik.values.treeAddress!==""){
          const data = {
            treeLat: formik.values.treeLat,
            treeLong: formik.values.treeLong,
            treeAddress: formik.values.treeAddress,
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page ))
            // setActiveStep((prevStep) => prevStep + 1)
             editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
            handleComplete()
          }else{
            NotificationManager.error("Please select location")
          }       
        break;
        case 5:
          if(formik.values.treeMapImage!==""){
          handleStatus()
          
          const treeMap={
            treeMapImage:formik.values.treeMapImage
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId, page))
            editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, treeMap)):
            trees?._id ? dispatch(editTrees(reportId, trees?._id, treeMap)):
             dispatch(addTree(reports?._id, treeMap))
              handleComplete()
          }else{
            NotificationManager.error("Click on save image button to save Image")
          }       
        break;
        case 6:
          if(formik.values.treeImage.length > 0){
            handleStatus()
            const treesImages={
              treeImages:formik.values.treeImage
            }
            const page ={
              pageNumber:activeStep,
              status:status
            }
              dispatch(updateReport(reportId,page ))
              editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, treesImages)):
              trees?._id ? dispatch(editTrees(reportId, trees?._id, treesImages)):
              dispatch(addTree(reports?._id, treesImages))
              handleComplete()
            }          
        break;
        case 7:
          if(formik.values.species){
            handleStatus()
          const data ={
            species:formik.values.species?._id
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page))
            dispatch({type:"SAVE_SPECIES", payload:formik.values.species})
             editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
              handleComplete()
          }          
          
        break;   
        case 8:
          if(formik.values.treeHeight!=="" && formik.values.treeHeight!==undefined && formik.values.treeHeightUnit!=="null" && formik.values.treeHeightUnit!==""){
            handleStatus()
          const data ={
            treeHeight:formik.values.treeHeight,
            treeHeightUnit: formik.values.treeHeightUnit
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
          dispatch(updateReport(reportId,page))
          editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
              trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
          dispatch(addTree(reports?._id, data))
          handleComplete()
        }   
        break;   
        case 9:
          if(formik.values.healthRating!=="" && formik.values.healthRating!=="null" && formik.values.healthRating!== undefined){
            handleStatus()
          const data ={
            healthRating:formik.values.healthRating
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page))
             editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
              handleComplete()
          }          
        break;
        case 10:
          if(formik.values.hardscapedamage!=="" && formik.values.hardscapedamage!=="null" && formik.values.hardscapedamage!== undefined){
            handleStatus()
            const data ={
              hardScapeDamage:formik.values.hardscapedamage,
              damageReason: formik.values.damageReason ? formik.values.damageReason :"",
              hardScapeDamageImage: formik.values.hardScapeDamageImage ? formik.values.hardScapeDamageImage :"",
              hardScapeDamageImageCaption: formik.values.hardScapeDamageImageCaption ? formik.values.hardScapeDamageImageCaption:""
            }
            console.log(data)
            const page ={
              pageNumber:activeStep,
              status:status
            }
              dispatch(updateReport(reportId,page))
              editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
              trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
              dispatch(addTree(reports?._id, data))
                handleComplete()   
            }
        break;
        case 11:
          if(formik.values.level!=="" && formik.values.level!=="null" && formik.values.level!== undefined){
            handleStatus()
          const data ={
            inspectionLevel:formik.values.level
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page))
             editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
              handleComplete()
          }
        break;
        case 12:
          if(formik.values.treeDistance!=="" && formik.values.treeDistance!=="null" && formik.values.treeDistance!== undefined){
          handleStatus()
            const data ={
              isTreeDistance:formik.values.treeDistance,
              treeDistanceDesc: formik.values.treeDistanceDesc ? formik.values.treeDistanceDesc : "",
              treeDistanceImage: formik.values.treeDistanceImage ? formik.values.treeDistanceImage:"",
              treeDistanceImageCaption: formik.values.treeDistanceImageCaption ? formik.values.treeDistanceImageCaption:""
            }
            const page ={
              pageNumber:activeStep,
              status:status
            }
              dispatch(updateReport(reportId,page))
              editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
              trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
              dispatch(addTree(reports?._id, data))
                handleComplete()
            }    
        break;
        case 13:
          if(formik.values.heritageTree!=="" && formik.values.heritageTree!=="null" && formik.values.heritageTree!== undefined){
          handleStatus()
          const data ={
            isHeritageTree:formik.values.heritageTree,
            heritageDesc: formik.values.heritageDesc ? formik.values.heritageDesc : "",
            heritageImage: formik.values.heritageImage ? formik.values.heritageImage:"",
            heritageImageCaption: formik.values.heritageImageCaption? formik.values.heritageImageCaption:""
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page))
             editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
              handleComplete()
          }
        break;
        case 14:       
        if(formik.values.jurisdiction!=="" && formik.values.jurisdiction!==undefined && formik.values.jurisdiction!=="null"){
          handleStatus()
            const data = {
              jurisdiction:formik.values.jurisdiction
            }
            const page = {
              pageNumber : activeStep,
              status:status
            }
            dispatch(updateReport(reportId,page))
            editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
         trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
           dispatch(addTree(reports?._id, data))
             handleComplete()
            }   
      break;
      case 15:       
      if(formik.values.diseasePresent!=="" && formik.values.diseasePresent!==undefined && formik.values.diseasePresent!=="null"){
        handleStatus()
          const data = {
            diseasePresent:formik.values.diseasePresent,
            diseasePresentDesc: formik.values.diseasePresentDesc? formik.values.diseasePresentDesc:"",
            diseasePresentImage: formik.values.diseasePresentImage? formik.values.diseasePresentImage:"",
            diseasePresentImageCaption: formik.values.diseasePresentImageCaption ? formik.values.diseasePresentImageCaption:""
          }
          const page = {
            pageNumber : activeStep,
            status:status
          }
          dispatch(updateReport(reportId,page))
          editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
       trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
         dispatch(addTree(reports?._id, data))
           handleComplete()
          }   
    break;
        case 16:       
          if(formik.values.observations!=="" && formik.values.observations!=="My Observation for this tree is"){
            handleStatus()
              const data = {
                observations:formik.values.observations
              }
              const page = {
                pageNumber : activeStep,
                status:status
              }
                dispatch(updateReport(reportId,page))
                editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
              trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
                dispatch(addTree(reports?._id, data))
                  handleComplete()
              }   
        break;
        case 17:
          if(formik.values.secondaryReport!=="" && formik.values.secondaryReport!=="null" && formik.values.secondaryReport!==undefined){
            handleStatus()
            const data ={
              isSecondaryReportRequired: formik.values.secondaryReport
            }
            const page ={
              pageNumber:activeStep,
              status:status
            }
            dispatch(updateReport(reportId,page))
            editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
            trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
              handleComplete()
          }   
          break;
        case 18:              
        if(formik.values.recomendation!=="" && formik.values.recomendation!=="null" && formik.values.recomendation!== undefined){
          handleStatus()
            const data ={
              recomendation:formik.values.recomendation,
              recomendationDesc : formik.values.recomendationDesc ? formik.values.recomendationDesc : ""
            }
            const page ={
              pageNumber:activeStep,
              status:status
            }
              dispatch(updateReport(reportId,page))
              editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
              trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
              dispatch(addTree(reports?._id, data))
                handleComplete()
            }
        break;       
        default:
        break;
      }
    }
  });

  const handleStepClick = (step) => {
    const reportId = editReport?._id
    if(formik.values.reportName){
      setActiveStep(step)
    }
    else{
      NotificationManager.error("Report name is mandatory")
    }
    switch(activeStep){
      case 0:
        if(formik.values.reportName!==""){
          handleStatus()
          const data ={
            reportName: formik.values.reportName ? formik.values.reportName:"",
            pageNumber:activeStep,
            status:status
          }
            reportId ? dispatch(updateReport(reportId, data)):
            dispatch(addReport(data))
           handleCompleteWithDots()
              setActiveStep(step)  
        }        
      break;
      case 1:
        if(formik.values.client!==""){
          handleStatus()
          const data ={
          reportName: formik.values.reportName ? formik.values.reportName : "",
          client: formik.values.client ? formik.values.client?._id : "",
          property: "",
          pageNumber: activeStep,
          status: status
        }
        setProperties("")
          reportId ? dispatch(updateReport(reportId, data)):
          dispatch(addReport(data))
          handleCompleteWithDots()
          setActiveStep(step)
        }    
      break;
      case 2:
        if(formik.values.property!==""){
          handleStatus()
        const data ={
          pageNumber:activeStep,
          property: formik.values.property ? formik.values.property?._id:"",
          status:status
        }
        reportId ? dispatch(updateReport(reportId, data)):
        dispatch(addReport(data))
       handleCompleteWithDots()
              setActiveStep(step)                    
        }
      break;
      case 3:
        if(formik.values.objective!== "" && formik.values.objective!=="The Objective of this report is" && formik.values.objective!== undefined){
          handleStatus()
        const data ={
          pageNumber:activeStep,
          objective: formik.values.objective ? formik.values.objective :"",
          status:status
        }
          reportId ? dispatch(updateReport(reportId, data)):
          dispatch(addReport(data))
         handleCompleteWithDots()
              setActiveStep(step)          
      }
      break;
      case 4:
        handleStatus()
        setShow(false)
        if(formik.values.treeLat!==""&& formik.values.treeLong!==""&& formik.values.treeAddress!==""){
        const data = {
          treeLat: formik.values.treeLat,
          treeLong: formik.values.treeLong,
          treeAddress: formik.values.treeAddress,
        }
        const page ={
          pageNumber:activeStep,
          status:status
        }
          dispatch(updateReport(reportId,page ))
          // setActiveStep((prevStep) => prevStep + 1)
           editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
          dispatch(addTree(reports?._id, data))
         handleCompleteWithDots()
        setActiveStep(step)
        }else{
          NotificationManager.error("Please select location")
        }       
      break;
      case 5:
        if(formik.values.treeMapImage!==""){
        handleStatus()
        
        const treeMap={
          treeMapImage:formik.values.treeMapImage
        }
        const page ={
          pageNumber:activeStep,
          status:status
        }
          dispatch(updateReport(reportId, page))
          editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, treeMap)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, treeMap)):
           dispatch(addTree(reports?._id, treeMap))
           handleCompleteWithDots()
              setActiveStep(step)
        }else{
          NotificationManager.error("Click on save image button to save Image")
        }       
      break;
      case 6:
        if(formik.values.treeImage.length > 0){
          handleStatus()
          const treesImages={
            treeImages:formik.values.treeImage
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page ))
            editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, treesImages)):
            trees?._id ? dispatch(editTrees(reportId, trees?._id, treesImages)):
            dispatch(addTree(reports?._id, treesImages))
            handleCompleteWithDots()
            setActiveStep(step)
          }          
      break;
      case 7:
        if(formik.values.species){
          handleStatus()
        const data ={
          species:formik.values.species?._id
        }
        const page ={
          pageNumber:activeStep,
          status:status
        }
          dispatch(updateReport(reportId,page))
          dispatch({type:"SAVE_SPECIES", payload:formik.values.species})
           editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
          dispatch(addTree(reports?._id, data))
           handleCompleteWithDots()
              setActiveStep(step)
        }          
        
      break;   
      case 8:
        if(formik.values.treeHeight!=="" && formik.values.treeHeight!==undefined && formik.values.treeHeightUnit!=="null" && formik.values.treeHeightUnit!==""){
          handleStatus()
        const data ={
          treeHeight:formik.values.treeHeight,
          treeHeightUnit:formik.values.treeHeightUnit
        }
        const page ={
          pageNumber:activeStep,
          status:status
        }
        dispatch(updateReport(reportId,page))
        editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
            trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
        dispatch(addTree(reports?._id, data))
       handleCompleteWithDots()
              setActiveStep(step)
      }   
      break;   
      case 9:
        if(formik.values.healthRating!=="" && formik.values.healthRating!=="null" && formik.values.healthRating!== undefined){
          handleStatus()
        const data ={
          healthRating:formik.values.healthRating
        }
        const page ={
          pageNumber:activeStep,
          status:status
        }
          dispatch(updateReport(reportId,page))
           editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
          dispatch(addTree(reports?._id, data))
           handleCompleteWithDots()
              setActiveStep(step)
        }          
      break;
      case 10:
        if(formik.values.hardscapedamage!=="" && formik.values.hardscapedamage!=="null" && formik.values.hardscapedamage!== undefined){
          handleStatus()
          const data ={
            hardScapeDamage:formik.values.hardscapedamage,
            damageReason: formik.values.damageReason ? formik.values.damageReason :"",
            hardScapeDamageImage: formik.values.hardScapeDamageImage ? formik.values.hardScapeDamageImage :"",
            hardScapeDamageImageCaption: formik.values.hardScapeDamageImageCaption ? formik.values.hardScapeDamageImageCaption:""
          }
          console.log(data)
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page))
            editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
            trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
             handleCompleteWithDots()
              setActiveStep(step)   
          }
      break;
      case 11:
        if(formik.values.level!=="" && formik.values.level!=="null" && formik.values.level!== undefined){
          handleStatus()
        const data ={
          inspectionLevel:formik.values.level
        }
        const page ={
          pageNumber:activeStep,
          status:status
        }
          dispatch(updateReport(reportId,page))
           editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
          dispatch(addTree(reports?._id, data))
           handleCompleteWithDots()
              setActiveStep(step)
        }
      break;
      case 12:
        if(formik.values.treeDistance!=="" && formik.values.treeDistance!=="null" && formik.values.treeDistance!== undefined){
        handleStatus()
          const data ={
            isTreeDistance:formik.values.treeDistance,
            treeDistanceDesc: formik.values.treeDistanceDesc ? formik.values.treeDistanceDesc : "",
            treeDistanceImage: formik.values.treeDistanceImage ? formik.values.treeDistanceImage:"",
            treeDistanceImageCaption: formik.values.treeDistanceImageCaption ? formik.values.treeDistanceImageCaption:""
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page))
            editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
            trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
             handleCompleteWithDots()
              setActiveStep(step)
          }    
      break;
      case 13:
        if(formik.values.heritageTree!=="" && formik.values.heritageTree!=="null" && formik.values.heritageTree!== undefined){
        handleStatus()
        const data ={
          isHeritageTree:formik.values.heritageTree,
          heritageDesc: formik.values.heritageDesc ? formik.values.heritageDesc : "",
          heritageImage: formik.values.heritageImage ? formik.values.heritageImage:"",
          heritageImageCaption: formik.values.heritageImageCaption? formik.values.heritageImageCaption:""
        }
        const page ={
          pageNumber:activeStep,
          status:status
        }
          dispatch(updateReport(reportId,page))
           editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
          dispatch(addTree(reports?._id, data))
           handleCompleteWithDots()
              setActiveStep(step)
        }
      break;
      case 14:       
        if(formik.values.jurisdiction!=="" && formik.values.jurisdiction!==undefined && formik.values.jurisdiction!=="null"){
          handleStatus()
            const data = {
              jurisdiction:formik.values.jurisdiction
            }
            const page = {
              pageNumber : activeStep,
              status:status
            }
            dispatch(updateReport(reportId,page))
            editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
           trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
           dispatch(addTree(reports?._id, data))
            handleCompleteWithDots()
               setActiveStep(step)
            }   
      break;
      case 15:       
      if(formik.values.diseasePresent!=="" && formik.values.diseasePresent!==undefined && formik.values.diseasePresent!=="null"){
        handleStatus()
          const data = {
            diseasePresent:formik.values.diseasePresent,
            diseasePresentDesc: formik.values.diseasePresentDesc? formik.values.diseasePresentDesc:"",
            diseasePresentImage: formik.values.diseasePresentImage? formik.values.diseasePresentImage:"",
            diseasePresentImageCaption: formik.values.diseasePresentImageCaption ? formik.values.diseasePresentImageCaption:""
          }
          const page = {
            pageNumber : activeStep,
            status:status
          }
          dispatch(updateReport(reportId,page))
          editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
         trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
         dispatch(addTree(reports?._id, data))
          handleCompleteWithDots()
             setActiveStep(step)
          }   
          break;
      case 16:       
        if(formik.values.observations!=="" && formik.values.observations!=="My Observation for this tree is"){
          handleStatus()
            const data = {
              observations:formik.values.observations
            }
            const page = {
              pageNumber : activeStep,
              status:status
            }
              dispatch(updateReport(reportId,page))
              editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
              trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
              dispatch(addTree(reports?._id, data))
               handleCompleteWithDots()
              setActiveStep(step)
            }   
      break;
      case 17:
        if(formik.values.secondaryReport!=="" && formik.values.secondaryReport!=="null" && formik.values.secondaryReport!==undefined){
          handleStatus()
          const data ={
            isSecondaryReportRequired: formik.values.secondaryReport
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
          dispatch(updateReport(reportId,page))
          editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
          trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
          dispatch(addTree(reports?._id, data))
           handleCompleteWithDots()
         setActiveStep(step)
        }   
        break;
      case 18:              
      if(formik.values.recomendation!=="" && formik.values.recomendation!=="null" && formik.values.recomendation!== undefined){
        handleStatus()

          const data ={
            recomendation:formik.values.recomendation,
            recomendationDesc : formik.values.recomendationDesc ? formik.values.recomendationDesc : ""
          }
          const page ={
            pageNumber:activeStep,
            status:status
          }
            dispatch(updateReport(reportId,page))
            editTree?.report === reportId ? dispatch(editTrees(editTree?.report, editTree?._id, data)):
            trees?._id ? dispatch(editTrees(reportId, trees?._id, data)):
            dispatch(addTree(reports?._id, data))
             handleCompleteWithDots()
           setActiveStep(step)
          }
      break;       
      default:
      break;
    }
    
  }


  const treeCondition = editTree || formik.values
  useEffect(()=>{ 
    if(formik.values.reportName){
      const newCompleted = completed
      newCompleted[0] = true
      setCompleted(newCompleted)
    }
    else{
      const newCompleted = completed
      newCompleted[0] = false
      setCompleted(newCompleted)
    }
    if(formik.values.client){
      const newCompleted = completed
      newCompleted[1] = true
      setCompleted(newCompleted)
    } else{
      const newCompleted = completed
      newCompleted[1] = false
      setCompleted(newCompleted)
    }
    if(formik.values.property){
      const newCompleted = completed
      newCompleted[2] = true
      setCompleted(newCompleted)
    } else{
      const newCompleted = completed
      newCompleted[2] = false
      setCompleted(newCompleted)
    }
    if(formik.values.objective!== "The Objective of this report is" && formik.values.objective!== undefined){
      const newCompleted = completed
      newCompleted[3] = true
      setCompleted(newCompleted)
    } else{
      const newCompleted = completed
      newCompleted[3] = false
      setCompleted(newCompleted)
    }
    if(formik.values.treeLat!=="" && formik.values.treeLong!=="" && formik.values.treeAddress!=="" && formik.values.treeAddress!==undefined){
      const newCompleted = completed
      newCompleted[4] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[4] = false
      setCompleted(newCompleted)
    }
    if(formik.values.treeMapImage!=="" && formik.values.treeMapImage!== undefined){
      const newCompleted = completed
      newCompleted[5] = true
      setCompleted(newCompleted)
    }
    else{
      const newCompleted = completed
      newCompleted[5] = false
      setCompleted(newCompleted)
    }
    if(formik.values.treeImage?.length>0){
      const newCompleted = completed
      newCompleted[6] = true
      setCompleted(newCompleted)
    }
    else{
      const newCompleted = completed
      newCompleted[6] = false
      setCompleted(newCompleted)
    }
    if(formik.values.species){
      const newCompleted = completed
      newCompleted[7] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[7] = false
      setCompleted(newCompleted)
    }
    if(formik.values.treeHeight!=="" && formik.values.treeHeight!==undefined){
      const newCompleted = completed
      newCompleted[8] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[8] = false
      setCompleted(newCompleted)
    }
    if(formik.values.healthRating){
      const newCompleted = completed
      newCompleted[9] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[9] = false
      setCompleted(newCompleted)
    }
    if(formik.values.hardscapedamage){
      const newCompleted = completed
      newCompleted[10] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[10] = false
      setCompleted(newCompleted)
    }
    if(formik.values.level){
      const newCompleted = completed
      newCompleted[11] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[11] = false
      setCompleted(newCompleted)
    }
    if(formik.values.treeDistance!=="" && formik.values.treeDistance!=="null" && formik.values.treeDistance!==undefined){
      const newCompleted = completed
      newCompleted[12] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[12] = false
      setCompleted(newCompleted)
    }
    if(formik.values.heritageTree!=="" && formik.values.heritageTree!=="null" && formik.values.heritageTree!==undefined ){
      const newCompleted = completed
      newCompleted[13] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[13] = false
      setCompleted(newCompleted)
    }
    if(formik.values.jurisdiction!=="" && formik.values.jurisdiction!==undefined && formik.values.jurisdiction!=="null"){
      const newCompleted = completed
      newCompleted[14] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[14] = false
      setCompleted(newCompleted)
    }
    if(formik.values.diseasePresent!=="" && formik.values.diseasePresent!==undefined && formik.values.diseasePresent!=="null"){
      const newCompleted = completed
      newCompleted[15] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[15] = false
      setCompleted(newCompleted)
    }
    if(formik.values.observations!=="My Observation for this tree is" && formik.values.observations!==undefined){
      const newCompleted = completed
      newCompleted[16] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[16] = false
      setCompleted(newCompleted)
    }
    if(formik.values.secondaryReport!=="" && formik.values.secondaryReport!=="null" && formik.values.secondaryReport!==undefined){
      const newCompleted = completed
      newCompleted[17] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[17] = false
      setCompleted(newCompleted)
    }
    if(formik.values.recomendation!=="" && formik.values.recomendation!=="null" && formik.values.recomendation!== undefined){
      const newCompleted = completed
      newCompleted[18] = true
      setCompleted(newCompleted)
    }else{
      const newCompleted = completed
      newCompleted[18] = false
      setCompleted(newCompleted)
    }
  },[formik.values, editTree])


  const formContent = (step) => {
    switch(step) {
      case 0:
        return <ReportDetail formik={formik} />;
      case 1:
        return <ClientDetail formik={formik} setClients={setClients} />;
      case 2:
        return <PropertyDetail formik={formik} setProperties={setProperties} />;
      case 3:
        return <Objective formik={formik} setObjective={setObjective}/>;
      case 4:
        return <AddTree formik={formik} updateData ={updateData} show={show} handleTreeClick={handleTreeClick} setShow={setShow} setEditTreeClick={setEditTreeClick} setActiveStep={setActiveStep} editTreeClick={editTreeClick}/>;
      case 5:
        return formik.values.treeLat ? <MapImage formik = {formik} setEditTreeData ={setEditTreeData} setActiveStep={setActiveStep} setShow={setShow} staticMap = {staticMap} canvasRef = {canvasRef} editTreeData={editTreeData} editClick={editClick}/>: null
      case 6:
        return <TreeImage formik={formik} image={image} setImage={setImage}/>;
      case 7:
        return <Species formik={formik} />;
      case 8:
        return <TreeHeight formik={formik} />;
      case 9:
        return <HealthRating formik={formik} />;
      case 10:
        return <HardscapeDamage formik={formik} />;
      case 11:
        return <InspectionLevel formik={formik} />;
      case 12:
        return <TreeDistance formik={formik} />;
      case 13:
        return <HeritageTree formik={formik} />;
      case 14:
        return <TreeJurisdiction formik ={formik} />
      case 15:
        return <DiseasePresent formik={formik}/>
      case 16:
        return <Observations formik={formik} />;
      case 17:
        return <SecondaryReport formik={formik} />;
      case 18:
        return <Recomendation formik={formik} />;
      case 19:
      return <GenerateReport formik= {formik}  isFormValid={isFormValid} setIsFormValid={setIsFormValid} setActiveStep={setActiveStep} setEditClick={setEditClick}/>;
      default:
        return <div>404: Not Found</div>
    }
  };

  const handleMoreClick = () =>{
    setActiveStep(4)
    setHandleTreeClick(true)
    dispatch ({type:"EMPTY TREES", payload:{}})
    dispatch({type:"EMPTY_EDIT_TREE", payload:{}})
    formik.resetForm({
      values:{
        treeLat: "",
        treeLong: "",
        treeAddress:"",
        treeImage :[],
        treeMapImage:  "",
        species: "",
        treeHeight: "",
        healthRating: "",
        hardscapedamage:"",
        hardScapeDamageImage:"",
        hardScapeDamageImageCaption:"",
        damageReason: "",
        level: "",
        treeDistance: "",
        treeDistanceDesc: "",
        treeDistanceImage:"",
        treeDistanceImageCaption:"",
        heritageTree: "",
        heritageDesc: "",
        heritageImage:"",
        heritageImageCaption:"",
        observations: "",
        secondaryReport:"",
        jurisdiction:"",
        diseasePresent:"",
        diseasePresentDesc:"",
        diseasePresentImage:"",
        diseasePresentImageCaption:"",
        recomendation: "",
      }
    })
  }

  return (
    <>
      <Card
        style={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", borderRadius:8, backgroundColor:"#FCFBFD"}}
      >
      <CardContent style={{paddingLeft:10}}>
        <Box sx={{ my: 5 }}>
            <Typography variant="h4" align="center">
              Edit Report Detail
            </Typography>
            <Typography variant="subtitle2" align="center" sx={{ mt: 2 }}>
              {/* React Material UI multi step form with basic form validation
              logic. */}
            </Typography>
          </Box>
          <Stepper activeStep = {activeStep} nonLinear  sx={{ py: 3}} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={index} completed={completed[index]}>
                <StepLabel StepIconProps={{
                  classes:{
                    active:classes.icon,
                    completed:classes.icon
                  }
                }}
                disabled={true}
                onClick={()=> handleStepClick(index)}
                // active={activeStep === index}
                // onClick= {()=>{activeStep > index && setActiveStep(index)}}
                >{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
    {/* <Grid container justifyContent="center" spacing={4} sx={{mt:4}}>
      */}
        <Grid
          item
          xs={12}
          sx={{ padding: '20px' }}
        >
          {formContent(activeStep)}
        </Grid>
        {formik.errors.submit && (
          <Grid
            item
            xs={12}
          >
            <FormHelperText error>
              {formik.errors.submit}
            </FormHelperText>
          </Grid>

        )}
        <Grid
          item
          xs={12}
        >
          <Box sx={{ display: "flex", justifyContent: "center" ,gap:5, pb:5}}>
            {activeStep === steps.length - 1 ? (
            <>
             <Button
              variant="contained"
              size="large" style={{backgroundColor:"rgb(115 74 153)", width:"auto"}}>
              Generate Report
            </Button>
             <Button
              onClick={handleMoreClick}
              variant="contained"
              size="large"
              style={{backgroundColor:"rgb(115 74 153)" , width:"auto"}}>
              Add More Tree
           </Button>
           </>
          ) :
          <>
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            variant="contained"
            size="large"
            style={{backgroundColor:"lightgray", color:activeStep !== 0 && "black", width:140}}
          >
            Back
          </Button>
          {(activeStep !== 4 || show) && <Button onClick = {formik.handleSubmit} size="large" variant="contained" style={{backgroundColor: "rgb(115 74 153)", width:"auto"}}>
           Save & Next
          </Button>}
          </>
           }
          </Box>
        </Grid>
      {/* </Grid> */}
     </CardContent>
     </Card>
    </>
  )
}

export default EditReport